import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";

export default function Jc_timelive() {
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [date, setDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchTaskDetails();
  }, []);

  const fetchTaskDetails = () => {
    setIsLoading(true);
    let endpoint = `/cust_available_total?login_user=${user.id}`;

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
        } else {
          setIsLoading(false);
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });
  };
  console.log(tasks);

  return (
    <>
      <div className="container mt-1">
        <div className="row mb-2">
          <h1 className="mb-1">JC Time Availablity</h1>
        </div>
        <div className="table-responsive">
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped">
              <thead className="table-primary">
                <tr>
                  <th className="text-danger">No</th>
                  <th>Name</th>
                  <th>Total Time</th>
                  <th>Total Pending</th>
                  <th>Today</th>
                  <th>Tomorrow</th>
                  <th>Day-after</th>
                  
                  {/* Add other fields as necessary */}
                </tr>
              </thead>
              <tbody>
                {tasks.map((taskuser, index) => (
                  <tr key={taskuser.id}>
                    <td>{index + 1}</td>
                    <td className="text-uppercase">
                      {taskuser.name} {taskuser.last_name}
                    </td>
                    <td>
                      <b>{taskuser.total_est_time}</b> Hours
                    </td>
                    <td>
                      <td width="17%">
                        <div className="progress">
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                              width: `${taskuser.total_pending_percent}%`,
                            }}
                            aria-valuenow={taskuser.total_pending_percent}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {taskuser.total_pending_percent}%
                          </div>
                        </div>
                        <div className="row">
                          <span className="text-center col-12">
                            <b>{taskuser.total_pending} Tasks</b>
                          </span>
                        </div>
                      </td>
                    </td>

                    {/* Today logic */}
                    <td width="17%">
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{ width: `${taskuser.today_percentage}%` }}
                          aria-valuenow={taskuser.today_percentage}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {taskuser.today_percentage}%
                        </div>
                      </div>
                      <div className="row">
                        <span className="text-center col-12">
                          <b>{taskuser.today_est_time} Hr</b>
                        </span>
                      </div>
                    </td>
                    {/* Tommorrw logic */}
                    <td width="17%">
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{ width: `${taskuser.tommorrow_percentage}%` }}
                          aria-valuenow={taskuser.tommorrow_percentage}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {taskuser.tommorrow_percentage}%
                        </div>
                      </div>
                      <div className="row">
                        <span className="text-center col-12">
                          <b>{taskuser.tommorrow_est_time} Hr</b>
                        </span>
                      </div>
                    </td>

                    {/* Dayafter logic */}
                    <td width="17%">
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{ width: `${taskuser.dayafter_percentage}%` }}
                          aria-valuenow={taskuser.dayafter_percentage}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {taskuser.dayafter_percentage}%
                        </div>
                      </div>
                      <div className="row">
                        <span className="text-center col-12">
                          <b>{taskuser.dayafter_est_time} Hr</b>
                        </span>
                      </div>
                    </td>

                 
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
